export function parseJwt(token) {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(atob(base64))
}

export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

export function flattenObject(obj) {
    let toReturn = {}
    let flatobject
    for (let i in obj) {
        //// console.log(i+ ' ' + typeof(obj[i]));
        if (!obj.hasOwnProperty(i)) {
            continue
        }
        //Exclude arrays from the final result
        //Check this http://stackoverflow.com/questions/4775722/check-if-object-is-array
        if (obj[i] && Array === obj[i].constructor) {
            continue
        }
        if (typeof obj[i] === 'object') {
            flatobject = flattenObject(obj[i])
            for (let x in flatobject) {
                if (!flatobject.hasOwnProperty(x)) {
                    continue
                }
                //Exclude arrays from the final result
                if (flatobject[x] && Array === flatobject.constructor) {
                    continue
                }
                toReturn[i + (isNaN(x) ? '.' + x : '')] = flatobject[x]
            }
        } else {
            toReturn[i] = obj[i]
        }
    }
    return toReturn
}

export function unflattenObject(obj) {
    var result = {}
    for (var i in obj) {
        var keys = i.split('.')
        keys.reduce(function(r, e, j) {
            return (
                r[e] ||
                (r[e] = isNaN(Number(keys[j + 1]))
                    ? keys.length - 1 == j
                        ? obj[i]
                        : {}
                    : [])
            )
        }, result)
    }
    return result
}

export function createTree(items, rootNodeId = null, nodeCb = null) {
    if (!nodeCb) {
        nodeCb = (node, ret = {}) => {
            ret.id = node.id
            ret.key = node.id
            ret.name = node.name
            ret.title = node.name
            //ret.node = node
            ret.label = node.name
            return ret
        }
    }

    let mapper = node => {
        let ret = nodeCb(node)
        let children = items
            .filter(item => item.parent_id == node.id)
            .sort((a, b) => {
                if (a.name < b.name) return -1
                if (a.name > b.name) return 1
                return 0
            })
            .map(mapper)

        if (children.length > 0) {
            ret.children = children
        }

        return ret
    }

    return items.filter(item => item.parent_id == rootNodeId).map(mapper)
}

// export { parseJwt, flattenObject, unflattenObject, createTree, uuidv4 }
